<template>
  <img :alt="altImg" :src="srcUrl" />
</template>

<script>
import { CARRIERS } from './constants.js'

export default {
  name: 'TkCarrierLogo',
  props: {
    code: {
      type: String,
      required: true,
    },
  },
  computed: {
    srcUrl() {
      const img = CARRIERS[this.code] ? this.code : 'noimage'
      return require('@ota-frontend/shared-assets/images/carrier/' +
        img +
        '.jpg')
    },
    altImg() {
      if (CARRIERS[this.code]) {
        return CARRIERS[this.code].name
      }
      return ''
    },
  },
  AVAILABLE_CARRIERS: {
    codes: Object.keys(CARRIERS)
  }
}
</script>
